/** True when the page runs inside the Telegram client (not a regular browser tab). */
export function isInsideTelegramWebApp(): boolean {
  const tg = window.Telegram?.WebApp;
  if (!tg) {
    return false;
  }
  return tg.platform !== 'unknown' && tg.platform.length > 0;
}
